/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_SET_ALIQS_ITEM = {
  id: 'sub_nav_1',
  screenId: 'tax-set-aliqs',
  label: 'Alícuotas',
  description: 'Porcentajes de cada impuesto.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Cada impuesto puede tener una o más alícuotas (porcentajes). Por ejemplo IIBB con 3,5 % y 4,5 % según jurisdicción, o IVA 10,5 % y 21 %.',
      },
      {
        title: 'Paso 1 — Ver el listado',
        bullets: [
          'Interruptor «Solo activas» — activo por defecto.',
          'Columnas: ID, Impuesto, Alícuota (%), Activo.',
          'Tocá una fila para editar. Botón + para nueva alícuota.',
        ],
      },
      {
        title: 'Paso 2 — Nueva alícuota',
        fields: [
          { label: 'Impuesto', description: 'Impuesto activo al que corresponde la alícuota. Obligatorio.' },
          { label: 'Alícuota (%)', description: 'Porcentaje entre 0 y 100 (ej. 21 o 3,5). Obligatorio.' },
        ],
      },
      {
        title: 'Paso 3 — Editar o desactivar',
        bullets: [
          'Podés cambiar el impuesto asociado, el porcentaje y si está activa.',
          '«Desactivar» — deja de aplicarse en nuevos cálculos.',
        ],
      },
    ],
  },
}
